import { Typography } from "@mui/material"
import React from 'react';
import { i18n } from "../translate/i18n";
import { IEquipmentWithServices } from "../models/iequipmentWithServices";

export const renderBadgeStatus = (equip: IEquipmentWithServices) => {
	switch (equip.statusGlobal) {
		case 'inactive': return <Typography variant="caption">{i18n.t('equipmentBadgeStatus.inactive') as string}</Typography>
		case 'maintenance': return <Typography variant="caption">{i18n.t('equipmentBadgeStatus.maintenance') as string}</Typography>
		case 'valid': return <Typography variant="caption">{i18n.t('equipmentBadgeStatus.valid') as string}</Typography>
		case 'invalid': return <Typography variant="caption">{i18n.t('equipmentBadgeStatus.invalid') as string}</Typography>
		case 'validWithOpenedActions': return <Typography variant="caption">{i18n.t('equipmentBadgeStatus.validWithOpenedActions') as string}</Typography>
		default: return <Typography variant="caption">{i18n.t('equipmentBadgeStatus.valid') as string}</Typography>
	}
}

export const renderBadgeColor = (equip: IEquipmentWithServices) => {
	if(equip.active === false) {
		return 'secondary';
	}

	if(equip.statusGlobal === 'maintenance' && equip.active === true) {
		return 'maintenance';
	}

	switch (equip.statusGlobal) {
		case 'not defined': return 'notDefined';
		case 'inactive': return 'inactive';
		case 'maintenance': return 'maintenance';
		case 'valid': return 'valid';
		case 'invalid': return 'secondary';
		case 'validWithOpenedActions': return 'validWithOpenedActions';
		default: return 'primary';
	}
}